import { render } from "./approweIcon.vue?vue&type=template&id=4fb87598"
import script from "./approweIcon.vue?vue&type=script&lang=js"
export * from "./approweIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__